import { TokenClaims } from '@azure/msal-common';
import { useMemo } from 'react';
import { useAuthentication } from '../AuthenticationProvider';

type ExtensionKey<T extends string> = `extension_${T}`;
type Extension<T extends string> = Record<ExtensionKey<T>, string>;

export enum RoleType {
  Admin = 'ADMIN',
  Partner = 'PARTNER',
  Company = 'COMPANY'
}

interface Role {
  type: RoleType;
  customerId?: string;
  partnerId?: string;
}

interface User {
  firstName: string;
  lastName: string;
  email: string;
  customerId?: string;
  claims?: TokenClaims;
}

export const useUser = (): User => {
  const account = useAuthentication(state => state.account);
  if (!account) throw new Error('Missing accounts');

  return useMemo(() => {
    const { firstName, lastName, email } = account;
    const claims = account.claims as Record<string, string>;

    const customerId = claims[`extension_Customer`] as string;

    return {
      firstName,
      lastName,
      email,
      claims,
      customerId
    };
  }, [account]);
};
export const useCustomerId = (): string => {
  const user = useUser();
  if (!user.customerId) throw new Error('Missing customer');
  return user.customerId;
};
